<section *ngIf="listsForResource?.length > 0">
  <h2 class="alpha h3" i18n="@@listsForResource-heading">
    This item appears on the following lists
  </h2>
  <ul class="list-unstyled">
    <li *ngFor="let list of listsForResource">
      <a [routerLink]="[listRouteVersion, tenantCode, 'lists', list.id]">{{
        list.title
      }}</a>
    </li>
  </ul>
</section>

<section *ngIf="listsForResource?.length === 0">
  <p i18n="@@listsForResource-no-lists">
    This resource doesn't appear on any list yet.
  </p>
</section>
